// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_sfB","cls2":"JJHomePageSearch-cls2_OmR JJHomePageSearch-cls1_sfB"};